import React from "react";
import { MapPin } from "lucide-react";
import LpCta from "./LpCta";
import { DOCTOR } from "./lpData";

const LpHero = () => (
  <section className="bg-white aevos-grid-bg overflow-hidden border-b border-[#E0E0E0]" data-testid="lp-hero">
    <div className="aevos-container grid lg:grid-cols-12 gap-10 lg:gap-6 items-end pt-14 lg:pt-0">
      <div className="lg:col-span-7 lg:py-24 pb-2 fade-up">
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
          <span className="text-[#00C4FF]">Emagrecimento</span> com acompanhamento médico em Mogi das Cruzes
        </h1>
        <p className="mt-6 text-[#333333] text-base md:text-lg max-w-xl leading-relaxed">
          Avaliação médica individualizada para entender o que pode estar dificultando seus
          resultados e definir uma estratégia de emagrecimento de acordo com sua saúde, metabolismo
          e rotina.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-4">
          <LpCta location="hero">Agendar minha consulta</LpCta>
          <span className="inline-flex items-center gap-2 text-sm text-[#333333]">
            <MapPin size={16} className="text-[#00C4FF]" />
            {DOCTOR.attendance}
          </span>
        </div>
      </div>

      <div className="lg:col-span-5 relative flex justify-center lg:justify-end fade-up delay-2">
        <div className="relative w-full max-w-[440px]">
          <img
            src="/assets/dr-guilherme-lp-v2.jpg"
            alt="Dr. Guilherme Affonso"
            className="w-full h-auto block object-cover object-top max-h-[560px] lg:max-h-[680px]"
            data-testid="lp-hero-photo"
            draggable={false}
          />
          <div
            className="absolute left-0 right-0 bottom-0 bg-black border-t-2 border-[#00C4FF] px-5 py-4"
            data-testid="lp-hero-doctor-card"
          >
            <p className="font-display font-semibold !text-white text-base">{DOCTOR.name}</p>
            <p className="text-xs text-white/75 mt-0.5">{DOCTOR.specialty}</p>
            <p className="text-xs text-[#00C4FF] mt-1 tracking-wide">{DOCTOR.crm}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LpHero;
